<!-- RatingStars.vue -->
<template>
    <div class="rating-stars">
      <span
        v-for="star in totalStars"
        :key="star"
        @mouseenter="hoverRating(star)"
        @mouseleave="resetRating"
        @click="selectRating(star)"
      >
        <span :class="{ 'star-filled': star <= hoverRatingValue || star <= this.currentRating }">★</span>
      </span>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      modelValue: { // Correctly referencing modelValue
        type: Number,
        default: 0,
      },
      totalStars: {
        type: Number,
        default: 5,
      },
    },
    data() {
        return {
        currentRating: this.modelValue, // Use modelValue here
        hoverRatingValue: 0,
      };
    },
    watch: {
      modelValue(newValue) {
        this.currentRating = newValue; // Update currentRating when modelValue changes
      },
    },
    methods: {
      selectRating(rating) {
        this.$emit('update:modelValue', rating);
        this.hoverRatingValue = 0;
        this.currentRating = rating;
      },
      hoverRating(rating) {
        this.hoverRatingValue = rating;
      },
      resetRating() {
        this.hoverRatingValue = 0;
      },
    },
  };
  </script>
  
  <style scoped>
    .rating-stars {
      font-size: 25px;
      align-self: start;
    }
    
    .star-filled {
      color: gold;
      cursor: pointer;
      display: inline-block;
      transition: color 0.3s ease; /* Add transition for color change */
    }
  </style>
  